import { render, staticRenderFns } from "./Bzgmxsys.vue?vue&type=template&id=1a01edf5&scoped=true&"
import script from "./Bzgmxsys.vue?vue&type=script&lang=js&"
export * from "./Bzgmxsys.vue?vue&type=script&lang=js&"
import style0 from "./Bzgmxsys.vue?vue&type=style&index=0&id=1a01edf5&lang=less&scoped=true&"
import style1 from "./Bzgmxsys.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a01edf5",
  null
  
)

export default component.exports